"use strict";
var PZUploadImage = function PZUploadImage(props) {
    var pzTabAttribute = props.pzUploadImage;
    var pzAttrImageValue = props.pzUploadImage.promize_attribute_image_value;
    var images = props.pzActiveImages[pzTabAttribute.promize_tab_image_attribute_values_id] ? props.pzActiveImages[pzTabAttribute.promize_tab_image_attribute_values_id] : [];
    var imageFormats = '';
    var pzUploadImgDpiNotMatched = 0;
    var currAttributes = props.pzCustomizer.attributes[props.pzTab.promize_tab_id];
    var currTabAttributes = pzTabAttribute.promize_tab_attribute_id in currAttributes ? currAttributes[pzTabAttribute.promize_tab_attribute_id] : null;
    var currAttributeCode = currTabAttributes ? currTabAttributes.promize_attribute.attribute_code : null;
    return React.createElement(
        "div", {
            "class": "pz-upload-cover-section"
        },
        React.createElement(
            "div", {
                "class": "pz-upld-container"
            },
            React.createElement(
                "ul", {
                    "class": "pz-upld-list"
                },
                props.pzCopyObjectsKeys.length > 0 && props.pzCopyObjectsKeys.map(function(objKey, index) {
                    if (objKey.includes('image_' + pzTabAttribute.promize_tab_attribute_id)) {
                        var image = props.pzCanvasObject[objKey];
                        if (image) {
                            if ('dpiMatched' in image && image.dpiMatched == false) {
                                pzUploadImgDpiNotMatched++;
                            }
                            return React.createElement(
                                "li",
                                null,
                                " ",
                                React.createElement("img", {
                                    id: objKey,
                                    src: image.src
                                }),
                                React.createElement(
                                    "button", {
                                        "class": "pz-delete-upload",
                                        onClick: function onClick(e) {
                                            return props.pzRemoveImage(objKey);
                                        }
                                    },
                                    React.createElement("i", {
                                        "class": "fa fa-trash"
                                    }),
                                    React.createElement(
                                        "span",
                                        null,
                                        "Delete"
                                    )
                                )
                            );
                        }
                    }
                })
            )
        ),
        pzTabAttribute.max_image_limit !== images.length && currAttributeCode != "background" && React.createElement(
            "div", {
                "class": "pz-upload-wrapper"
            },
            React.createElement(
                "div", {
                    "class": "pz-upload-control"
                },
                React.createElement(
                    "div", {
                        "class": "pz-upload-content"
                    },
                    pzAttrImageValue.image_format.split(',').map(function(format) {
                        imageFormats += '.' + format + ' ';
                    }),
                    React.createElement(
                        "p", {
                            "class": "pz-info-text"
                        },
                        "Choose logo in ",
                        imageFormats,
                        " format(s)"
                    ),
                    React.createElement(
                        "p", {
                            "class": "pz-browse-text"
                        },
                        React.createElement("i", {
                            "class": "fa fa-cloud-upload"
                        }),
                        " Browse"
                    )
                ),
                React.createElement("input", {
                    type: "file",
                    "class": "pz-upload-file",
                    onChange: function onChange(e) {
                        return props.pzUpload(event, pzTabAttribute);
                    }
                })
            ),
            React.createElement(
                "div", {
                    className: "pz-upload-description"
                },
                React.createElement(
                    "p", {
                        "class": "error-msg-img-upload"
                    },
                    props.img_error_msg
                ),
                pzUploadImgDpiNotMatched > 0 && React.createElement(
                    "p", {
                        className: "pz-upload-warning"
                    },
                    "The image you uploaded may be of low resolution, which may impact the quality of the print on the lanyard. The customer service representative will contact you to request a better image quality."
                )
            )
        ),
        currAttributeCode == "background" && React.createElement(
            "div", {
                "class": "pz-upload-wrapper",
                onMouseOver: function onMouseOver(e) {
                    e.preventDefault();
                    props.HomeComponent.pzHoverHandler('Upload Custom Background', e);
                },
                onMouseOut: function onMouseOut(e) {
                    props.HomeComponent.pzHoverHandler('', e);
                }
            },
            React.createElement(
                "p", {
                    "class": "pz-upload-text"
                },
                React.createElement(
                    "span", {
                        "class": "pz-text-hglt",
                        onClick: function onClick(e) {
                            e.preventDefault(), props.pzOpenPopup(pzTabAttribute, props.pzTab);
                        }
                    },
                    React.createElement("i", {
                        "class": "fa fa-upload",
                        "aria-hidden": "true"
                    }),
                    " "
                ),
                " "
            )
        )
    );
};
